import * as React from 'react';
import { Layout } from 'react-admin';
import CustomHeader from '../customHeader/CustomHeader';
import CustomMenu from "../menu/customMenu/CustomMenu";

const CustomLayout = (props:any) => <Layout {...props} appBar={CustomHeader} menu={CustomMenu}/>;

export default CustomLayout;